module.exports = __webpack_public_path__ + "img/ch07_05_列车进站.c6245a92.jpg";